import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useEditProjectMembers = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useMutation(async (members) => {
    await fetchContext.authAxios.put(`/projects/${projectId}/members`, members);
  });
};
